import React from 'react';
import { useNavigate } from 'react-router-dom';

import iconScan from 'url:../assets/icon-scan.svg';

// Static browser-capability check -- evaluated once at module load, not on
// every render. No `navigator.mediaDevices` (very old browsers, some
// locked-down webviews) means no getUserMedia, so the button would only
// ever lead to a dead end; render nothing instead.
const hasCamera =
  typeof navigator !== 'undefined' && !!navigator.mediaDevices?.getUserMedia;

export function ScanButton({
  variant,
  className = '',
}: {
  variant: 'prominent' | 'compact';
  className?: string;
}) {
  const navigate = useNavigate();

  if (!hasCamera) return null;

  const goToScan = () => navigate('/scan');

  if (variant === 'compact') {
    return (
      <button
        type="button"
        onClick={goToScan}
        aria-label="Σάρωση barcode"
        title="Σάρωση barcode"
        className={
          'flex-none flex items-center justify-center w-10 h-10 rounded-full text-gray-500 hover:text-lime-700 hover:bg-lime-50 transition-colors ' +
          className
        }
      >
        <img src={iconScan} className="w-6 h-6" alt="" />
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={goToScan}
      aria-label="Σάρωση barcode"
      className={
        'w-full sm:w-auto flex items-center justify-center gap-2 rounded-full border-2 border-lime-600 text-lime-700 font-semibold px-6 py-3 hover:bg-lime-50 transition-colors ' +
        className
      }
    >
      <img src={iconScan} className="w-5 h-5" alt="" />
      Σάρωση barcode
    </button>
  );
}
